import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import "./index.css";

const tagManagerArgs = {
  gtmId: "GTM-M9L33W7",
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback="טוען...">
        <App />
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>
);
